import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import { VerifyEmail } from './pages/VerifyEmail';
import AdminLayout from './components/AdminLayout';
import Overview from './pages/Overview';
import UserManagement from './pages/UserManagement';
import TenantManagement from './pages/TenantManagement';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import { useAdminAuth } from './store/adminAuth';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAdminAuth();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/auth/verify-email" element={<VerifyEmail />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <Routes>
                <Route path="/" element={<Overview />} />
                <Route path="/users" element={<UserManagement />} />
                <Route path="/tenants" element={<TenantManagement />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </AdminLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
